import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const BackgroundElements = () => {
  // Reduced number of particles
  const particles = Array.from({ length: 10 }, (_, i) => ({
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 2 + 1,
    speed: Math.random() * 0.5 + 0.2,
    opacity: Math.random() * 0.15 + 0.05,
  }));

  return (
    <>
      {/* Base gradient background */}
      <div className="fixed inset-0 bg-gradient-to-br from-white via-[#fff5eb] to-[#f9f6f4] pointer-events-none" />

      {/* Enhanced grid pattern with subtle animation - reduced opacity */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        {/* Main grid pattern - higher contrast */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.08]" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 10 L40 10" stroke="#946e5d" strokeWidth="0.6" fill="none" />
              <path d="M0 20 L40 20" stroke="#946e5d" strokeWidth="0.6" fill="none" />
              <path d="M0 30 L40 30" stroke="#946e5d" strokeWidth="0.6" fill="none" />
              <path d="M10 0 L10 40" stroke="#946e5d" strokeWidth="0.6" fill="none" />
              <path d="M20 0 L20 40" stroke="#946e5d" strokeWidth="0.6" fill="none" />
              <path d="M30 0 L30 40" stroke="#946e5d" strokeWidth="0.6" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>

        {/* Grid pulse rings - removed */}

        {/* Animated grid highlights - removed */}
      </div>

      {/* Floating geometric shapes - reduced */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        {/* Square - kept one shape with reduced animation */}
        <motion.div
          className="absolute w-[150px] h-[150px] border-2 border-[#ff8c42]/10 rounded-2xl"
          style={{
            top: '15%',
            right: '10%',
          }}
          animate={{
            rotate: [0, 90, 180, 270, 360],
            opacity: [0.1, 0.2, 0.1],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }}
        />
        
        {/* Other shapes removed */}
      </div>
      
      {/* Mouse-following gradient spotlight - removed */}

      {/* Enhanced animated particles with glow - reduced */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        {particles.map((particle, i) => (
          <motion.div
            key={`particle-${i}`}
            className="absolute rounded-full"
            initial={{ 
              x: `${particle.x}vw`, 
              y: `${particle.y}vh`,
              opacity: particle.opacity,
              background: 'radial-gradient(circle, rgba(255,140,66,0.5) 0%, rgba(255,140,66,0) 70%)'
            }}
            animate={{ 
              y: [
                `${particle.y}vh`, 
                `${(particle.y + 30) % 100}vh`, 
                `${(particle.y + 60) % 100}vh`, 
                `${(particle.y + 90) % 100}vh`
              ],
              x: [
                `${particle.x}vw`, 
                `${(particle.x + 15) % 100}vw`, 
                `${(particle.x + 5) % 100}vw`, 
                `${(particle.x - 10) % 100}vw`
              ],
              opacity: [particle.opacity, particle.opacity],
            }}
            transition={{ 
              duration: 40 / particle.speed,
              repeat: Infinity,
              ease: "linear"
            }}
            style={{
              width: `${particle.size * 2}px`,
              height: `${particle.size * 2}px`,
              filter: 'blur(1px)'
            }}
          />
        ))}
      </div>
    </>
  );
};

export default BackgroundElements; 